import type { StrategyShape } from '@luna/utils';

export const OP_IFRAME_ELEMENT_ID = 'op';
export const RP_IFRAME_ELEMENT_ID = 'rp';

export type OidcStrategyType = 'RFC' | 'CSAS';

export type OidcConfig = {
    baseFederatedLoginUrl: string;
    onSessionChanged: () => Promise<void>;
    opIframe: string;
    clientId: string;
    sessionState?: string;
    strategy: OidcStrategyType;
    publicUrl?: string;
};

export type WindowWithRpSdk = typeof window & {
    rpSdk: {
        baseFederatedLoginUrl: string;
        clientId: string;
        sessionState: string;
        strategy: OidcStrategyType;
    };
    RP_SDK: {
        RP_IFRAME_PARAMS: { CLIENT_ID: string; OP_BASE_FQDN: string; SESSION_STATE: string };
    };
};

export type AuthConfig = {
    auth: {
        fedLoginUrl: string;
        fedLoginForDevUrl?: string;
        // clientSecret?: string;
        // fedLoginBaseUrl: string;
        // opIframe: string;
        tokenUrl: string;
        // endSessionUrl: string;
        codeChallengeMethod: string;
        redirectUri: string;
        responseType: string;
        clientSecret?: string;
        scope?: string;
    };
    clientId: string;
    logoutUrl: {
        default: string;
    };
    reverseProxyUrl?: string;
    reverseProxyUrl2?: string;
};

export type LoginStrategyOptions = {
    config: AuthConfig;
};

export type LoginStrategyShape = StrategyShape<Promise<void>>;
